import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { setCalendarCountriesAction, setCalendarCountryHolidaysAction } from 'editor/src/store/design/slice';
import { setRequestedCalendarCountriesAction } from 'editor/src/store/gridConfig/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

const requestCalendarCountriesOperation = (countries: string[]) => (dispatch: ThunkDispatch) => {
  batch(() => {
    dispatch(setCalendarCountriesAction(countries));
    if (countries.length) {
      dispatch(setRequestedCalendarCountriesAction(countries));
    } else {
      dispatch(setRequestedCalendarCountriesAction(null));
      dispatch(setCalendarCountryHolidaysAction({ countries, events: [] }));
    }
  });

  if (countries.length) {
    sendPostMessage('calendar.requestEvents', { countries });
  }
};

export default requestCalendarCountriesOperation;
